import { render, staticRenderFns } from "./TabPartidas.vue?vue&type=template&id=4a008bd9&scoped=true&"
import script from "./TabPartidas.vue?vue&type=script&lang=js&"
export * from "./TabPartidas.vue?vue&type=script&lang=js&"
import style0 from "./TabPartidas.vue?vue&type=style&index=0&id=4a008bd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a008bd9",
  null
  
)

export default component.exports